// TODO: remove this and use the ssr utils in the utils folder instead
// because it's neither configurable nor should it be a singleton

/**
 * get SSR helpers
 * @return {Object} SSR helpers
 */
export default function ssrService() {
  return {
    /**
     * @description Return True If Client Side Render
     * @returns {boolean}
     */
    isCSR: function isCSR() {
      return typeof window !== 'undefined';
    }
  };
}